  document.addEventListener('change', function (e) {
    if (e.target.matches('.size-selector')) {
      const select = e.target;
      const newVariantId = select.value;
      const line = select.getAttribute('data-line');
      const previousVariantId = select.getAttribute('data-current-variant');

      const row = select.closest('tr.cart-item');
      let currentQuantity = 1;
      if (row) {
        const qtyInput = row.querySelector('.quantity__input');
        if (qtyInput) {
          currentQuantity = Number(qtyInput.value) || 1;
        }
      }

      if (newVariantId === previousVariantId) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(line),
          quantity: 0,
        }),
      })
        .then(() => {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: Number(newVariantId),
              quantity: currentQuantity,
            }),
          });
        })
        .then(() => {
          fetch(window.location.pathname + '?section_id=main-cart-items')
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCart = doc.querySelector('cart-items');
              const currentCart = document.querySelector('cart-items');
              if (newCart && currentCart) {
                currentCart.innerHTML = newCart.innerHTML;
              } else {
                window.location.reload();
              }
            });
        })
    }
  });